import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { useNavigate, Link,useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { PDFDocument } from "pdf-lib";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { HiDotsHorizontal } from "react-icons/hi";
import Bluedart from "../assets/bluedart.png";
import Delehivery from "../assets/delehivery.png";
import EcomExpress from "../assets/ecom-expresss.avif";
import Shadowfax from "../assets/shadowfax.png";
import Xpressbees from "../assets/xpressbees.png";
import Shiprocket from "../assets/shiprocket.webp";
import NimbusPost from "../assets/nimbuspost.webp";
import ShreeMaruti from "../assets/shreemaruti.png";
import DTDC from "../assets/dtdc.png";
import { FaTruck, FaPlane } from "react-icons/fa";
import { FaFilter, FaBars } from "react-icons/fa";
import { FiMoreHorizontal, FiArrowLeft, FiArrowRight } from "react-icons/fi";
import { DateRange } from "react-date-range";
import dayjs from "dayjs";
import { ChevronDown } from "lucide-react";
import ThreeDotLoader from "../Loader"
const carrierLogos = {
  Bluedart,
  Delhivery: Delehivery,
  EcomExpress,
  Shadowfax,
  Xpressbees,
  NimbusPost,
  Shiprocket,
  ShreeMaruti,
  DTDC,
};


// const AllOrder = () => {
const AllOrder = (filterOrder) => {
  const [dropdownOpen, setDropdownOpen] = useState(null);
  const [orders, setOrders] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [selectedOrders, setSelectedOrders] = useState([]); // Track selected orders
  const [actionDropdownOpen, setActionDropdownOpen] = useState(false); // New dropdown state
  const [searchQuery, setSearchQuery] = useState("");
  const [loadingOrderId, setLoadingOrderId] = useState(null);
  // const navigate = useNavigate();
  const dropdownRef = useRef(null);
  const dropdownRefs = useRef([]);

  const toggleButtonRefs = useRef([]);

  const actionDropdownRef = useRef(null);

  const [loading, setLoading] = useState(true); // Loading state
  const [page, setPage] = useState(1); // Track current page
  const [limit, setLimit] = useState(20); // You can make this dynamic if needed
  const [totalPages, setTotalPages] = useState(1);

  const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

  const navigate = useNavigate();
  const handleTrackingByAwb = (awb) => {
    navigate(`/dashboard/order/tracking/${awb}`);
  };
  const [pickupStatus, setPickupStatus] = useState("Generate Pickup"); // Initial button text
  const [isDisabled, setIsDisabled] = useState(false); // Button disable state

  const [searchBy, setSearchBy] = useState("awbNumber");
  const [inputValue, setInputValue] = useState("");

  const [desktopDropdownOpen, setDesktopDropdownOpen] = useState(false);
  const [mobileDropdownOpen, setMobileDropdownOpen] = useState(false);

  const desktopActionRef = useRef(null);
  const mobileActionRef = useRef(null);

  const [courierOptions, setCourierOptions] = useState([]); // All unique couriers
  const [selectedCourier, setSelectedCourier] = useState(""); // Selected courier
  const [showCourierDropdown, setShowCourierDropdown] = useState(false);
  const [showCourierDropdownMobile, setShowCourierDropdownMobile] =
    useState(false);
  const courierDropdownRef = useRef(null);
  const courierDropdownButtonRef = useRef(null);
  const courierDropdownRefMobile = useRef(null);
  const courierDropdownButtonRefMobile = useRef(null);

  const [orderId, setOrderId] = useState("");
  const [paymentType, setPaymentType] = useState("");
  const [dateRange, setDateRange] = useState([
    { startDate: null, endDate: null, key: "selection" },
  ]);
  const [showDropdown, setShowDropdown] = useState(false);
  const [showCustom, setShowCustom] = useState(false);
  const [pickupAddresses, setPickupAddresses] = useState([]); // Store pickup addresses
  const [selectedPickupAddress, setSelectedPickupAddress] = useState(""); // Track selected pickup address
  const [showPickupDropdown, setShowPickupDropdown] = useState(false); // Toggle dropdown visibility
  const [showPaymentTypeDropdown, setShowPaymentTypeDropdown] = useState(false);
  const [showFilters, setShowFilters] = useState(false);
  const [showSearchByDropdown, setShowSearchByDropdown] = useState(false);
  const awbDropdownRef = useRef(null);
  const awbDropdownButtonRef = useRef(null);
  const [showSearchByDropdownMobile, setShowSearchByDropdownMobile] =
    useState(false);
  const awbDropdownRefMobile = useRef(null);
  const awbDropdownButtonRefMobile = useRef(null);

  const paymentRef = useRef(null);
  const dateRef = useRef(null);
  const pickupRef = useRef(null);
  const calendarRef = useRef(null);
  const paymentButtonRef = useRef(null);
  const pickupButtonRef = useRef(null);
  const dateButtonRef = useRef(null);

  const [selectedStatus, setSelectedStatus] = useState("All");
  const [showStatusDropdown, setShowStatusDropdown] = useState(false);
  const [showStatusDropdownMobile, setShowStatusDropdownMobile] =
    useState(false);
  const statusDropdownRef = useRef(null);
  const statusDropdownButtonRef = useRef(null);
  const statusDropdownRefMobile = useRef(null);
  const statusDropdownButtonRefMobile = useRef(null);
const {id}=useParams();
  const [tempDateRange, setTempDateRange] = useState([
    { startDate: null, endDate: null, key: "selection" },
  ]);
  const dateOptions = [
    {
      label: "Today",
      range: () => ({
        startDate: dayjs().startOf("day").toDate(),
        endDate: dayjs().endOf("day").toDate(),
      }),
    },
    {
      label: "Yesterday",
      range: () => ({
        startDate: dayjs().subtract(1, "day").startOf("day").toDate(),
        endDate: dayjs().subtract(1, "day").endOf("day").toDate(),
      }),
    },
    {
      label: "Last 7 Days",
      range: () => ({
        startDate: dayjs().subtract(6, "day").startOf("day").toDate(),
        endDate: dayjs().endOf("day").toDate(),
      }),
    },
    {
      label: "Last 30 Days",
      range: () => ({
        startDate: dayjs().subtract(29, "day").startOf("day").toDate(),
        endDate: dayjs().endOf("day").toDate(),
      }),
    },
    {
      label: "Last Week",
      range: () => ({
        startDate: dayjs().subtract(1, "week").startOf("week").toDate(),
        endDate: dayjs().subtract(1, "week").endOf("week").toDate(),
      }),
    },
    {
      label: "Last Month",
      range: () => ({
        startDate: dayjs().subtract(1, "month").startOf("month").toDate(),
        endDate: dayjs().subtract(1, "month").endOf("month").toDate(),
      }),
    },
    {
      label: "This Year",
      range: () => ({
        startDate: dayjs().startOf("year").toDate(),
        endDate: dayjs().endOf("day").toDate(),
      }),
    },
    {
      label: "Custom",
      custom: true,
    },
  ];

  const statusOptions = [
    "All",
    "new",
    "Ready To Ship",
    "In-transit",
    "Out for Delivery",
    "Delivered",
    "Cancelled",
    "Lost",
    "Damaged",
    "RTO",
    "RTO In-transit",
    "RTO Delivered",
    "RTO Lost",
    "RTO Damaged",
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      // Payment dropdown outside click
      if (
        paymentRef.current &&
        !paymentRef.current.contains(event.target) &&
        paymentButtonRef.current &&
        !paymentButtonRef.current.contains(event.target)
      ) {
        setShowPaymentTypeDropdown(false);
      }

      // Pickup dropdown outside click
      if (
        pickupRef.current &&
        !pickupRef.current.contains(event.target) &&
        pickupButtonRef.current &&
        !pickupButtonRef.current.contains(event.target)
      ) {
        setShowPickupDropdown(false);
      }

      //this is for the awb number dropdwon

      if (
        awbDropdownRef.current &&
        !awbDropdownRef.current.contains(event.target) &&
        awbDropdownButtonRef.current &&
        !awbDropdownButtonRef.current.contains(event.target)
      ) {
        setShowSearchByDropdown(false);
      }

      // Mobile AWB dropdown outside click
      if (
        awbDropdownRefMobile.current &&
        !awbDropdownRefMobile.current.contains(event.target) &&
        awbDropdownButtonRefMobile.current &&
        !awbDropdownButtonRefMobile.current.contains(event.target)
      ) {
        setShowSearchByDropdownMobile(false);
      }

      if (
        courierDropdownRef.current &&
        !courierDropdownRef.current.contains(event.target) &&
        courierDropdownButtonRef.current &&
        !courierDropdownButtonRef.current.contains(event.target)
      ) {
        setShowCourierDropdown(false);
      }
      if (
        courierDropdownRefMobile.current &&
        !courierDropdownRefMobile.current.contains(event.target) &&
        courierDropdownButtonRefMobile.current &&
        !courierDropdownButtonRefMobile.current.contains(event.target)
      ) {
        setShowCourierDropdownMobile(false);
      }
      //this is for status
      if (
        statusDropdownRef.current &&
        !statusDropdownRef.current.contains(event.target) &&
        statusDropdownButtonRef.current &&
        !statusDropdownButtonRef.current.contains(event.target)
      ) {
        setShowStatusDropdown(false);
      }
      if (
        statusDropdownRefMobile.current &&
        !statusDropdownRefMobile.current.contains(event.target) &&
        statusDropdownButtonRefMobile.current &&
        !statusDropdownButtonRefMobile.current.contains(event.target)
      ) {
        setShowStatusDropdownMobile(false);
      }
      // Date dropdown and calendar outside click logic
      const insideDateButton = dateButtonRef.current?.contains(event.target);
      const insideDateDropdown = dateRef.current?.contains(event.target);
      const insideCalendar = calendarRef.current?.contains(event.target);

      if (showCustom) {
        if (!insideDateDropdown && !insideCalendar && !insideDateButton) {
          setShowDropdown(false);
          setShowCustom(false);
        }
      } else if (showDropdown) {
        if (!insideDateDropdown && !insideDateButton) {
          setShowDropdown(false);
        }
      }
      // Action dropdown (desktop)
      if (
        desktopActionRef.current &&
        !desktopActionRef.current.contains(event.target)
      ) {
        setDesktopDropdownOpen(false);
      }

      // Action dropdown (mobile)
      if (
        mobileActionRef.current &&
        !mobileActionRef.current.contains(event.target)
      ) {
        setMobileDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [
    showDropdown,
    showCustom,
    showPaymentTypeDropdown,
    showPickupDropdown,
    desktopDropdownOpen,
    mobileDropdownOpen,
    showSearchByDropdown,
    showSearchByDropdownMobile,
    showCourierDropdown,
    showCourierDropdownMobile,
  ]);

  const handleDateOptionClick = (option) => {
    if (option.custom) {
      setTempDateRange([...dateRange]);
      setShowDropdown(false);

      requestAnimationFrame(() => {
        setShowCustom(true);
      });
    } else {
      const range = option.range();
      setDateRange([
        {
          startDate: new Date(range.startDate),
          endDate: new Date(range.endDate),
          key: "selection",
        },
      ]);
      setShowDropdown(false);
      setShowCustom(false);
    }
  };

  const toggleDropdown = (index) => {
    // Delay the toggle so it doesn't conflict with the mousedown event
    setTimeout(() => {
      setDropdownOpen((prev) => (prev === index ? null : index));
    }, 0);
  };

  const options = [
    { label: "Waybill", value: "awbNumber" },
    { label: "Order ID", value: "orderId" },
    // { label: "Tracking ID", value: "trackingId" },
  ];

  const getPlaceholder = () => {
    switch (searchBy) {
      case "orderId":
        return "Search by Order ID";
      case "trackingId":
        return "Search by Tracking ID";
      default:
        return "Search by Waybill Number";
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const clickedInsideAnyDropdown = dropdownRefs.current.some(
        (ref) => ref && ref.contains(event.target)
      );
      const clickedAnyToggleButton = toggleButtonRefs.current.some(
        (ref) => ref && ref.contains(event.target)
      );

      if (!clickedInsideAnyDropdown && !clickedAnyToggleButton) {
        setDropdownOpen(null);
      }
    };

    // ✅ Use 'click' instead of 'mousedown'
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        actionDropdownRef.current &&
        !actionDropdownRef.current.contains(event.target)
      ) {
        setActionDropdownOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleLabel = async (id) => {
    try {
      const response = await fetch(
        `${REACT_APP_BACKEND_URL}/printlabel/generate-pdf/${id}`
      );
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `Label-${id}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error("Error downloading invoice:", error);
    }
  };

  const handleManifest = async (id) => {
    try {
      const response = await axios.get(
        `${REACT_APP_BACKEND_URL}/manifest/generate-pdf/${id}`,
        {
          responseType: "blob",
        }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "manifest.pdf");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading the PDF:", error);
    }
  };

  const handleInvoice = async (id) => {
    try {
      const response = await fetch(
        `${REACT_APP_BACKEND_URL}/printinvoice/download-invoice/${id}`
      );
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download = `invoice-${id}.pdf`;
      document.body.appendChild(a);
      a.click();
      a.remove();
    } catch (error) {
      console.error("Error downloading invoice:", error);
    }
  };

  const handleClone = async (id) => {
    const [session, token] = document.cookie.split("=");
    let payload = {
      id: id,
    };
    const response = await axios.post(
      `${REACT_APP_BACKEND_URL}/order/clone`,
      payload,
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
    setRefresh(true);
    console.log(response);
  };

  const fetchOrders = async () => {
    setLoading(true);
    try {
      const [session, token] = document.cookie.split("=");

      const [pickupCity, pickupState] =
        selectedPickupAddress?.split(", ") || [];

      const params = {
        id,
        page,
        limit,
        status: selectedStatus !== "All" ? selectedStatus : undefined,
        searchQuery,
        paymentType,
        startDate: dateRange[0].startDate?.toISOString(),
        endDate: dateRange[0].endDate?.toISOString(),
        pickupContactName: selectedPickupAddress || undefined,
      };

      // Add search by orderId, awbNumber, or trackingId
      if (inputValue.trim()) {
        if (searchBy === "orderId") params.orderId = inputValue.trim();
        if (searchBy === "awbNumber") params.awbNumber = inputValue.trim();
        if (searchBy === "trackingId") params.trackingId = inputValue.trim();
      }
      if (selectedCourier) {
        params.courierServiceName = selectedCourier;
      }

      const response = await axios.get(
        `${REACT_APP_BACKEND_URL}/order/orders`,
        {
          params,
          headers: {
            authorization: `Bearer ${token}`,
          },
        }
      );

      setOrders(response.data.orders);
      setTotalPages(response.data.totalPages);
      if (response.data.pickupLocations) {
        setPickupAddresses(response.data.pickupLocations);
      }

      // Extract unique courierServiceName from all orders
      setCourierOptions(response.data.courierServices || []);
    } catch (error) {
      console.error("Error fetching orders:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchOrders();
  }, [
    page,
    limit,
    searchQuery,
    paymentType,
    dateRange,
    selectedPickupAddress,
    inputValue,
    searchBy,
    selectedCourier,
    selectedStatus,
  ]);

  const handleCancelOrder = async (orderData) => {
    try {
      const [session, token] = document.cookie.split("=");
      await axios.post(
        `${REACT_APP_BACKEND_URL}/order/cancelOrdersAtBooked`,
        orderData,
        {
          headers: { authorization: `Bearer ${token}` },
        }
      );
      toast.success("Order canceled successfully!");
    } catch (error) {
      console.error("Error canceling order:", error);
      toast.error("Failed to cancel order. Please try again.");
    }
  };

  const handleBulkDownload = async () => {
    if (selectedOrders.length === 0) {
      toast.error("No orders selected for download.");
      return;
    }

    try {
      const mergedPdf = await PDFDocument.create();

      for (let orderId of selectedOrders) {
        const response = await fetch(
          `${REACT_APP_BACKEND_URL}/printinvoice/download-invoice/${orderId}`
        );
        const blob = await response.blob();
        const existingPdfBytes = await blob.arrayBuffer();

        const existingPdf = await PDFDocument.load(existingPdfBytes);
        const copiedPages = await mergedPdf.copyPages(
          existingPdf,
          existingPdf.getPageIndices()
        );

        copiedPages.forEach((page) => mergedPdf.addPage(page));
      }

      const mergedPdfBytes = await mergedPdf.save();
      const mergedBlob = new Blob([mergedPdfBytes], {
        type: "application/pdf",
      });
      saveAs(mergedBlob, "bulk-invoices.pdf");

      toast.success("Invoices downloaded successfully!");
    } catch (error) {
      console.error("Error downloading invoices:", error);
      toast.error("Failed to download invoices.");
    }
  };

  const handleExportExcel = () => {
    if (selectedOrders.length === 0) {
      toast.error("No orders selected for export.");
      return;
    }

    // Filter only selected orders
    const exportData = orders
      .filter((order) => selectedOrders.includes(order._id))
      .map((order) => ({
        "Order ID": order.orderId,
        "Order Status": order.status,
        "Order Date": new Date(order.createdAt).toLocaleString(),
        "Sender Name": order.pickupAddress?.contactName,
        "Sender Email": order.pickupAddress?.email,
        "Sender Phone": order.pickupAddress?.phoneNumber,
        "Sender Address": order.pickupAddress?.address,
        "Sender City": order.pickupAddress?.city,
        "Sender State": order.pickupAddress?.state,
        "Sender Pin": order.pickupAddress?.pinCode,
        "Receiver Name": order.receiverAddress?.contactName,
        "Receiver Email": order.receiverAddress?.email,
        "Receiver Phone": order.receiverAddress?.phoneNumber,
        "Receiver Address": order.receiverAddress?.address,
        "Receiver City": order.receiverAddress?.city,
        "Receiver State": order.receiverAddress?.state,
        "Receiver Pin": order.receiverAddress?.pinCode,
        "Payment Method": order.paymentDetails?.method,
        "Payment Amount": order.paymentDetails?.amount,
        Courier: order.courierServiceName,
        "AWB Number": order.awb_number,
        // Add more fields as needed
        Products: order.productDetails
          ?.map(
            (p) =>
              `Name: ${p.name}, SKU: ${p.sku}, Qty: ${p.quantity}, Price: ${p.unitPrice}`
          )
          .join(" | "),
      }));

    // Create worksheet and workbook
    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Orders");

    // Generate buffer and save
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([wbout], { type: "application/octet-stream" });
    saveAs(blob, "orders.xlsx");
  };

  // Handle "Select All" checkbox
  const handleSelectAll = () => {
    if (selectedOrders.length === orders.length) {
      setSelectedOrders([]); // Unselect all
    } else {
      setSelectedOrders(orders.map((order) => order._id)); // Select all
    }
    // console.log(selectedOrders)
  };

  // Handle individual row selection
  const handleCheckboxChange = (orderId) => {
    setSelectedOrders((prev) =>
      prev.includes(orderId)
        ? prev.filter((id) => id !== orderId)
        : [...prev, orderId]
    );
  };

  const filteredOrders = orders.filter(
    (order) =>
      // order.status === "Ready To Ship" &&
      order.orderId
        ?.toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase()) ||
      order.awb_number
        ?.toString()
        .toLowerCase()
        .includes(searchQuery.toLowerCase())
  );



const handleClearFilters = () => {
  setSearchQuery("");
  setInputValue("");
  setPaymentType("");
  setSelectedPickupAddress("");
  setSelectedCourier("");
  setDateRange([{ startDate: null, endDate: null, key: "selection" }]);
  setSearchBy("awbNumber");
  setSelectedStatus("All");
  setPage(1);
};


  return (
    <div className="w-full">
      {/* Desktop Table */}
      <div className="w-full">
        <div className="flex w-full flex-row justify-between items-center gap-2 sm:my-2 my-0 rounded-lg overflow-visible">
          <div className="hidden md:flex md:flex-row items-center gap-2 w-full">
            <input
              type="text"
              placeholder="Search by Name, Email, Phone"
              className="w-full h-9 sm:w-[180px] px-3 placeholder:text-[12px] text-[12px] font-[600] border-2 rounded-lg placeholder:font-[600] focus:outline-none placeholder:text-gray-500"
              onChange={(e) => setSearchQuery(e.target.value)}
              value={searchQuery}
            />

            {/* awbnumber filter */}
            <div className="flex w-full md:w-1/3" ref={awbDropdownRef}>
              {/* Custom Dropdown */}
              <div className="relative">
                <button
                  ref={awbDropdownButtonRef}
                  onClick={() => setShowSearchByDropdown((prev) => !prev)}
                  className="w-full h-9 px-3 text-[12px] font-[600] border-2 border-r-0 rounded-l-lg bg-white text-left focus:outline-none flex items-center justify-between text-gray-500"
                >
                  <span className="truncate">
                    {options.find((opt) => opt.value === searchBy)?.label ||
                      "Select"}
                  </span>
                  <ChevronDown
                    className={`w-4 h-4 ml-2 transform transition-transform ${
                      showSearchByDropdown ? "rotate-180" : ""
                    }`}
                  />
                </button>

                {showSearchByDropdown && (
                  <ul className="absolute z-10 w-full mt-1 bg-white border border-gray-300 rounded shadow text-[12px] font-[600] text-gray-500">
                    {options.map((opt) => (
                      <li
                        key={opt.value}
                        onClick={() => {
                          setSearchBy(opt.value);
                          setShowSearchByDropdown(false);
                        }}
                        className="px-3 py-2 hover:bg-green-50 cursor-pointer"
                      >
                        {opt.label}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              {/* Input Box */}
              <input
                type="text"
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
                placeholder={getPlaceholder()}
                className="w-full h-9  sm:w-[150px] text-[12px] font-[600] border-2 border-l-0 rounded-r-lg placeholder:font-[600] focus:outline-none placeholder:text-gray-500"
              />
            </div>

            {/* Payment Type Dropdown */}
            <div className="relative w-full md:w-1/6" ref={paymentRef}>
            <button
  className="w-full h-9 px-2 text-[12px] bg-white font-semibold border-2 rounded-lg focus:outline-none text-left flex items-center justify-between text-gray-500 whitespace-nowrap"

                onClick={() => {
                  setShowPaymentTypeDropdown((prev) => !prev);
                  setShowPickupDropdown(false);
                  setShowDropdown(false);
                }}
                ref={paymentButtonRef}
              >
                {paymentType || "Payment Type"}
                <ChevronDown
                  className={`w-4 h-4 ml-2 transform transition-transform ${
                    showPaymentTypeDropdown ? "rotate-180" : ""
                  }`}
                />
              </button>

              {showPaymentTypeDropdown && (
                <div className="absolute w-full bg-white border rounded shadow p-1 z-10 max-h-60 overflow-y-auto transition-all duration-300 ease-in-out">
                  {["Prepaid", "COD"].map((type) => (
                    <div
                      key={type}
                      className="cursor-pointer hover:bg-green-50 px-3 py-2 text-[12px] font-[600] text-gray-500"
                      onClick={() => {
                        setPaymentType(type);
                        setShowPaymentTypeDropdown(false);
                      }}
                    >
                      {type}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {/* CourierDropdown */}
            <div className="relative w-full md:w-1/5" ref={courierDropdownRef}>
              <button
                className="w-full bg-white sm:w-[150px] h-9 px-3 text-xs font-semibold border-2 rounded-lg focus:outline-none text-left flex items-center justify-between text-gray-500"
                onClick={() => {
                  setShowCourierDropdown((prev) => !prev);
                  setShowPickupDropdown(false);
                  setShowPaymentTypeDropdown(false);
                  setShowDropdown(false);
                }}
                ref={courierDropdownButtonRef}
              >
                {selectedCourier || "Select Courier"}
                <ChevronDown
                  className={`w-4 h-4 ml-2 transform transition-transform ${
                    showCourierDropdown ? "rotate-180" : ""
                  }`}
                />
              </button>
              {showCourierDropdown && (
                <div className="absolute w-full bg-white border rounded shadow p-1 z-10 max-h-40 overflow-y-auto transition-all duration-300 ease-in-out">
                  {courierOptions.map((courier, idx) => (
                    <div
                      key={idx}
                      className="cursor-pointer hover:bg-green-50 px-3 py-2 text-[12px] font-[600] text-gray-500"
                      onClick={() => {
                        setSelectedCourier(courier);
                        setShowCourierDropdown(false);
                      }}
                    >
                      <p className="text-[12px] font-[600] text-gray-500">{courier}</p>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Pickup Address Dropdown */}
            <div className="relative w-full md:w-1/5" ref={pickupRef}>
              <button
                className="w-full bg-white h-9 px-3 text-xs font-semibold border-2 rounded-lg focus:outline-none text-left flex items-center justify-between text-gray-500"
                onClick={() => {
                  setShowPickupDropdown((prev) => !prev);
                  setShowPaymentTypeDropdown(false);
                  setShowDropdown(false);
                }}
                ref={pickupButtonRef}
              >
                <span className="truncate w-full whitespace-nowrap overflow-hidden">
                  {selectedPickupAddress || "Select Pickup Address"}
                </span>
                <ChevronDown
                  className={`w-4 h-4 ml-2 flex-shrink-0 transform transition-transform ${
                    showPickupDropdown ? "rotate-180" : ""
                  }`}
                />
              </button>

              {showPickupDropdown && (
                <div className="absolute w-full bg-white border rounded shadow p-1 z-10 max-h-40 overflow-y-auto transition-all duration-300 ease-in-out">
                  {pickupAddresses.map((location, index) => (
                  <div
                    key={index}
                    className="cursor-pointer hover:bg-green-50 px-3 py-2 text-[12px] font-[600] text-gray-500"
                    onClick={() => {
                      setSelectedPickupAddress(location.contactName);
                      setShowPickupDropdown(false);
                    }}
                  >
                    <p className="text-[12px] font-[600] text-gray-500">
                      {location.contactName}
                    </p>
                  </div>
                ))}
                </div>
              )}
            </div>

            {/* Date Range Filter */}
            <div className="relative w-full md:w-2/6" ref={dateRef}>
              <button
                className="w-full sm:w-[140px] bg-white h-9 px-3 text-xs font-semibold border-2 rounded-lg focus:outline-none text-left flex items-center justify-between text-gray-500"
                onClick={() => {
                  if (showCustom) {
                    // If calendar open, close both calendar & dropdown
                    setShowDropdown(false);
                    setShowCustom(false);
                  } else {
                    // Toggle dropdown normally and close others
                    setShowDropdown((prev) => !prev);
                    setShowPickupDropdown(false);
                    setShowPaymentTypeDropdown(false);
                    setShowCustom(false);
                  }
                }}
                ref={dateButtonRef}
              >
                <span>
                  {dateRange[0].startDate && dateRange[0].endDate
                    ? `${dayjs(dateRange[0].startDate).format(
                        "DD/MM/YYYY"
                      )} - ${dayjs(dateRange[0].endDate).format("DD/MM/YYYY")}`
                    : "Select Date"}
                </span>
                <ChevronDown
                  className={`w-4 h-4 ml-2 transform transition-transform ${
                    showDropdown ? "rotate-180" : ""
                  }`}
                />
              </button>

              {/* Dropdown Options */}
              {showDropdown && (
                <div className="absolute w-full bg-white border rounded shadow p-2 z-[50] transition-all duration-300 ease-in-out">
                  <ul>
                    {dateOptions.map((option, idx) => (
                      <li
                        key={idx}
                        className="cursor-pointer hover:bg-green-50 px-3 py-2 text-xs font-[600] text-gray-500"
                        onClick={(e) => {
                          e.preventDefault();
                          handleDateOptionClick(option);
                        }}
                      >
                        {option.label}
                      </li>
                    ))}
                  </ul>
                </div>
              )}

              {/* Custom Calendar */}
              {showCustom && (
                <div
                  className="absolute w-full bg-white border rounded shadow p-2 z-[60] transition-all duration-600 ease-in-out"
                  ref={calendarRef}
                  onClick={(e) => e.stopPropagation()} // prevent calendar clicks from closing
                >
                  <DateRange
                    editableDateInputs={true}
                    onChange={(item) => setTempDateRange([item.selection])}
                    ranges={tempDateRange}
                    moveRangeOnFirstSelection={false}
                    showMonthAndYearPickers={false}
                    rangeColors={["#0CBB7D"]}
                    months={1}
                    direction="horizontal"
                    showDateDisplay={false}
                    className="custom-date-range w-[240px] h-[270px] text-xs scale-[0.90] origin-top"
                  />
                  <div className="flex justify-end gap-2 mt-2">
                    <button
                      className="bg-[#0CBB7D] text-white px-3 py-1 text-xs rounded"
                      onClick={(e) => {
                        e.stopPropagation(); // prevent button clicks from closing unexpectedly
                        setDateRange(tempDateRange);
                        setShowCustom(false);
                        setShowDropdown(false);
                      }}
                    >
                      Apply
                    </button>
                  </div>
                </div>
              )}
            </div>
            {/* Status filter */}
            <div
              className="relative w-full md:w-1/6 z-[10]"
              ref={statusDropdownRef}
            >
              <button
                className="w-full bg-white h-9 px-3 text-xs font-semibold border-2 rounded-lg focus:outline-none text-left flex items-center justify-between text-gray-500"
                onClick={() => setShowStatusDropdown((prev) => !prev)}
                ref={statusDropdownButtonRef}
              >
                {selectedStatus || "Status"}
                <ChevronDown
                  className={`w-4 h-4 ml-2 transform transition-transform ${
                    showStatusDropdown ? "rotate-180" : ""
                  }`}
                />
              </button>
              {showStatusDropdown && (
                <div className="absolute w-full sm:w-[150px] bg-white border rounded shadow p-1 z-10 max-h-60 overflow-y-auto transition-all duration-300 ease-in-out">
                  {statusOptions.map((status) => (
                    <div
                      key={status}
                      className="cursor-pointer hover:bg-green-50 px-3 py-2 text-[12px] font-[600] text-gray-500"
                      onClick={() => {
                        setSelectedStatus(status);
                        setShowStatusDropdown(false);
                        setPage(1);
                      }}
                    >
                      {status}
                    </div>
                  ))}
                </div>
              )}
            </div>
            {/* Action Button for Desktop */}
            <div
              className="relative hidden md:flex items-center gap-2"
              ref={desktopActionRef}
            >
              <button
                className="h-9 min-w-[110px] bg-white px-3 text-[12px] border-2 rounded-lg font-[600] text-gray-500 border-[#0CBB7D] bg-white hover:bg-gray-100 transition whitespace-nowrap"
                onClick={handleClearFilters}
                type="button"
              >
                Clear Filters
              </button>

              {/* ✅ Wrap the Actions button + dropdown in a relative container */}
              <div className="relative">
                <button
                  className={`h-9 min-w-[110px] px-3 text-[12px] border-2 rounded-lg font-[600] flex items-center gap-1 justify-center whitespace-nowrap ${
                    selectedOrders.length === 0
                      ? "border-gray-200 text-gray-400 cursor-not-allowed"
                      : "text-[#0CBB7D] border-[#0CBB7D]"
                  }`}
                  onClick={() =>
                    selectedOrders.length > 0 &&
                    setDesktopDropdownOpen(!desktopDropdownOpen)
                  }
                  disabled={selectedOrders.length === 0}
                >
                  <span>Actions▼</span>
                </button>

                <div
                  className={`absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-lg shadow-lg z-[100] overflow-hidden transition-all duration-300 ease-in-out ${
                    desktopDropdownOpen
                      ? "max-h-96 opacity-100 scale-100"
                      : "max-h-0 opacity-0 scale-95 pointer-events-none"
                  }`}
                >
                  <ul className="py-2 font-[600]">
                    <li
                      className="px-3 py-2 text-gray-700 hover:bg-green-100 cursor-pointer text-[10px]"
                      onClick={handleExportExcel}
                    >
                      Export
                    </li>
                    <li
                      className="px-3 py-2 text-gray-700 cursor-pointer text-[10px] hover:bg-green-100"
                      onClick={handleBulkDownload}
                    >
                      Download Invoices
                    </li>
                    
                  </ul>
                </div>
              </div>
            </div>
          </div>
          {/* New Dropdown */}
          <div className="flex gap-2 w-full flex-col md:flex-row">
            <div className="flex items-center justify-between gap-2 md:hidden relative">
              <input
                type="text"
                placeholder="Search by Name, Email, Phone"
                className="w-full h-8 px-3 placeholder:text-[12px] text-[12px] font-[600] border-2 rounded-lg placeholder:font-[600] focus:outline-none placeholder:text-gray-500"
                onChange={(e) => setSearchQuery(e.target.value)}
                value={searchQuery}
              />

              {/* FaFilter Button */}
              <button
                className="px-3 flex-1 flex items-center justify-center text-white bg-[#0CBB7D] h-8 rounded-lg border-2 border-[#0CBB7D] transition text-[12px] font-[600]"
                onClick={() => setShowFilters((prev) => !prev)}
              >
                <FaFilter className="text-white" />
              </button>
              <div ref={dropdownRef}>
                <button
                  className={`px-3 h-8 border-2 rounded-lg font-[600] flex items-center gap-1 ${
                    selectedOrders.length === 0
                      ? "border-gray-200 text-[10px] sm:text-[12px] cursor-not-allowed text-gray-400"
                      : "text-[#0CBB7D] border-[#0CBB7D] text-[10px] sm:text-[12px]"
                  }`}
                  onClick={() =>
                    selectedOrders.length > 0 &&
                    setActionDropdownOpen(!actionDropdownOpen)
                  }
                  disabled={selectedOrders.length === 0}
                >
                  <FaBars
                    className={`sm:hidden 
                          ${
                            selectedOrders.length === 0
                              ? "text-gray-400"
                              : "text-[#0CBB7D]"
                          }`}
                  />
                  <span className="hidden sm:inline">Actions ▼</span>
                </button>

                {actionDropdownOpen && (
                  <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-md shadow-lg z-[100]">
                    <ul className="py-2 font-[600]">
                      <li
                        className="px-4 py-2 text-gray-700 hover:bg-green-100 cursor-pointer text-[10px]"
                        onClick={handleExportExcel}
                      >
                        Export
                      </li>
                      <li
                        className="px-4 py-2 text-gray-700 hover:bg-green-100 cursor-pointer text-[10px]"
                        onClick={handleBulkDownload}
                      >
                        Download Invoices
                      </li>
                      {/* <li className="px-4 py-2 text-red-500 hover:bg-gray-100 cursor-pointer">
                            Cancel Selected Orders
                          </li> */}
                    </ul>
                  </div>
                )}
              </div>
            </div>

            {/* filter Section */}
            <div
              className={`transition-all duration-300 ease-in-out md:hidden ${
                showFilters
                  ? "max-h-[1000px] overflow-visible"
                  : "max-h-0 overflow-hidden"
              }`}
            >
              <div className="flex flex-col gap-2 overflow-visible">
                {/* awbnumber dropdown */}
                <div className="flex w-full md:w-1/3 max-w-md">
                  <div className="relative w-3/5" ref={awbDropdownRefMobile}>
                    <button
                      ref={awbDropdownButtonRefMobile}
                      onClick={() =>
                        setShowSearchByDropdownMobile((prev) => !prev)
                      }
                      className="w-full h-8 px-3 text-[12px] font-[600] border-2 border-r-0 rounded-l-lg bg-white text-left focus:outline-none flex items-center justify-between text-gray-500"
                    >
                      <span className="truncate">
                        {options.find((opt) => opt.value === searchBy)?.label ||
                          "Select"}
                      </span>
                      <ChevronDown
                        className={`w-4 h-4 ml-2 transform transition-transform ${
                          showSearchByDropdownMobile ? "rotate-180" : ""
                        }`}
                      />
                    </button>
                    {showSearchByDropdownMobile && (
                      <ul className="absolute z-[70] w-full mt-1 bg-white border border-gray-300 rounded shadow text-[12px] font-[600]">
                        {options.map((opt) => (
                          <li
                            key={opt.value}
                            onClick={() => {
                              setSearchBy(opt.value);
                              setShowSearchByDropdownMobile(false);
                            }}
                            className="px-3 py-2 hover:bg-gray-100 cursor-pointer text-gray-500 text-[12px] font-[600]"
                          >
                            {opt.label}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                  <input
                    type="text"
                    value={inputValue}
                    onChange={(e) => setInputValue(e.target.value)}
                    placeholder={getPlaceholder()}
                    className="w-full h-8 px-3 text-[12px] font-[600] border-2 border-l-0 rounded-r-lg placeholder:font-[600] focus:outline-none placeholder:text-gray-500"
                  />
                </div>

                {/* Payment Type Dropdown */}
                <div className="relative w-full z-[60]" ref={paymentRef}>
                  <button
                    className="w-full bg-white h-8 px-3 text-xs font-semibold border-2 rounded-lg focus:outline-none text-left flex items-center justify-between text-gray-500"
                    onClick={() => {
                      setShowPaymentTypeDropdown((prev) => !prev);
                      setShowPickupDropdown(false);
                      setShowDropdown(false);
                    }}
                  >
                    {paymentType || "Payment Type"}
                    <ChevronDown
                      className={`w-4 h-4 ml-2 transform transition-transform ${
                        showPaymentTypeDropdown ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  {showPaymentTypeDropdown && (
                    <div className="absolute w-full bg-white border rounded shadow p-1 z-[40] max-h-60 overflow-y-auto transition-all duration-300 ease-in-out">
                      {["Prepaid", "COD"].map((type) => (
                        <div
                          key={type}
                          className="cursor-pointer hover:bg-green-50 px-3 py-2 text-[12px] font-[600] text-gray-500"
                          onClick={() => {
                            setPaymentType(type);
                            setShowPaymentTypeDropdown(false);
                          }}
                        >
                          {type}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Courier Dropdown */}
                <div
                  className="relative w-full z-[50]"
                  ref={courierDropdownRefMobile}
                >
                  <button
                    className="w-full bg-white h-8 px-3 text-xs font-semibold border-2 rounded-lg focus:outline-none text-left flex items-center justify-between text-gray-500"
                    onClick={() =>
                      setShowCourierDropdownMobile((prev) => !prev)
                    }
                    ref={courierDropdownButtonRefMobile}
                  >
                    {selectedCourier || "Select Courier"}
                    <ChevronDown
                      className={`w-4 h-4 ml-2 transform transition-transform ${
                        showCourierDropdownMobile ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  {showCourierDropdownMobile && (
                    <div className="absolute w-full bg-white border rounded shadow p-1 z-[10] max-h-60 overflow-y-auto transition-all duration-300 ease-in-out">
                      {courierOptions.map((courier, idx) => (
                        <div
                          key={idx}
                          className="cursor-pointer hover:bg-green-50 px-3 py-2 text-[12px] font-[600] text-gray-500"
                          onClick={() => {
                            setSelectedCourier(courier);
                            setShowCourierDropdownMobile(false);
                          }}
                        >
                          <p className="text-[12px] font-[600] text-gray-500">{courier}</p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                {/* Pickup Address Dropdown */}
                <div className="relative w-full z-[30]" ref={pickupRef}>
                  <button
                    className="w-full h-8 px-3 text-xs font-semibold border-2 rounded-lg focus:outline-none text-left flex items-center justify-between bg-white text-gray-500"
                    onClick={() => {
                      setShowPickupDropdown((prev) => !prev);
                      setShowPaymentTypeDropdown(false);
                      setShowDropdown(false);
                    }}
                  >
                    {selectedPickupAddress
                      ? pickupAddresses.find(
                          (addr) => addr._id === selectedPickupAddress
                        )?.contactName || "Select Pickup Address"
                      : "Select Pickup Address"}
                    <ChevronDown
                      className={`w-4 h-4 ml-2 transform transition-transform ${
                        showPickupDropdown ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  {showPickupDropdown && (
                    <div className="absolute w-full bg-white border rounded shadow p-1 z-[30] max-h-60 overflow-y-auto transition-all duration-300 ease-in-out">
                      {pickupAddresses.map((location, index) => (
                  <div
                    key={index}
                    className="cursor-pointer hover:bg-green-50 px-3 py-2 text-[12px] font-[600] text-gray-500"
                    onClick={() => {
                      setSelectedPickupAddress(location.contactName);
                      setShowPickupDropdown(false);
                    }}
                  >
                    <p className="text-[12px] font-[600] text-gray-500">
                      {location.contactName}
                    </p>
                  </div>
                ))}
                    </div>
                  )}
                </div>

                {/* Date Range Filter */}
                <div className="relative w-full z-[20]" ref={dateRef}>
                  <button
                    className="w-full h-8 px-3 text-xs font-semibold border-2 rounded-lg focus:outline-none text-left flex items-center justify-between bg-white text-gray-500"
                    onClick={() => {
                      setShowDropdown((prev) => !prev);
                      setShowPickupDropdown(false);
                      setShowPaymentTypeDropdown(false);
                      setShowCustom(false);
                    }}
                  >
                    <span>
                      {dateRange[0].startDate && dateRange[0].endDate
                        ? `${dayjs(dateRange[0].startDate).format(
                            "DD/MM/YYYY"
                          )} - ${dayjs(dateRange[0].endDate).format(
                            "DD/MM/YYYY"
                          )}`
                        : "Select Date"}
                    </span>
                    <ChevronDown
                      className={`w-4 h-4 ml-2 transform transition-transform ${
                        showDropdown ? "rotate-180" : ""
                      }`}
                    />
                  </button>

                  {showDropdown && (
                    <div className="absolute w-full bg-white border rounded shadow p-2 z-[50] transition-all duration-300 ease-in-out">
                      <ul>
                        {dateOptions.map((option, idx) => (
                          <li
                            key={idx}
                            className="cursor-pointer hover:bg-green-50 px-3 py-2 text-xs font-[600] text-gray-500"
                            onClick={(e) => {
                              e.preventDefault();
                              handleDateOptionClick(option);
                            }}
                          >
                            {option.label}
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}

                  {/* Custom Calendar */}
                  {showCustom && (
                    <div
                      className="absolute w-full bg-white border rounded shadow p-2 z-[60] transition-all duration-600 ease-in-out"
                      ref={calendarRef}
                      onClick={(e) => e.stopPropagation()} // prevent calendar clicks from closing
                    >
                      <DateRange
                        editableDateInputs={true}
                        onChange={(item) => setTempDateRange([item.selection])}
                        ranges={tempDateRange}
                        moveRangeOnFirstSelection={false}
                        showMonthAndYearPickers={false}
                        rangeColors={["#0CBB7D"]}
                        months={1}
                        direction="horizontal"
                        showDateDisplay={false}
                        className="custom-date-range w-[290px] h-[290px] text-xs"
                      />
                      <div className="flex justify-end gap-2 mt-2">
                        <button
                          className="bg-[#0CBB7D] text-white px-3 py-1 text-xs rounded"
                          onClick={(e) => {
                            e.stopPropagation(); // prevent button clicks from closing unexpectedly
                            setDateRange(tempDateRange);
                            setShowCustom(false);
                            setShowDropdown(false);
                          }}
                        >
                          Apply
                        </button>
                      </div>
                    </div>
                  )}
                </div>

                {/* Status filter */}
                <div
                  className="relative w-full z-[10]"
                  ref={statusDropdownRefMobile}
                >
                  <button
                    className="w-full h-8 px-3 text-xs font-semibold border-2 rounded-lg focus:outline-none text-left flex items-center justify-between bg-white text-gray-500"
                    onClick={() => setShowStatusDropdownMobile((prev) => !prev)}
                    ref={statusDropdownButtonRefMobile}
                  >
                    {selectedStatus || "Status"}
                    <ChevronDown
                      className={`w-4 h-4 ml-2 transform transition-transform ${
                        showStatusDropdownMobile ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  {showStatusDropdownMobile && (
                    <div className="absolute w-full bg-white border rounded shadow p-1 z-[10] max-h-60 overflow-y-auto transition-all duration-300 ease-in-out">
                      {statusOptions.map((status) => (
                        <div
                          key={status}
                          className="cursor-pointer hover:bg-green-50 px-3 py-2 text-[12px] font-[600] text-gray-500"
                          onClick={() => {
                            setSelectedStatus(status);
                            setShowStatusDropdownMobile(false);
                            setPage(1);
                          }}
                        >
                          {status}
                        </div>
                      ))}
                    </div>
                  )}
                </div>

                <button
                  className="w-ful bg-white mt-1 h-8 text-xs font-semibold border-2 rounded-lg text-gray-500 border-[#0CBB7D] bg-white hover:bg-gray-100 transition"
                  onClick={handleClearFilters}
                  type="button"
                >
                  Clear Filters
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="hidden md:block relative">
        <table className="bg-white border w-full border-gray-300 rounded-lg">
          {/* Table Head */}
          <thead>
            <tr className="text-white bg-[#0CBB7D] border border-[#0CBB7D] text-[12px] font-[600]">
              <th className="py-2 px-3 text-center">
                <input
                  type="checkbox"
                  checked={
                    selectedOrders.length === orders.length && orders.length > 0
                  }
                  onChange={handleSelectAll}
                  className="cursor-pointer accent-[#0CBB7D] w-4"
                />
              </th>
              <th className="py-2 px-3 text-left">Order Details</th>
              <th className="py-2 px-3 text-left">Product Details</th>
              <th className="py-2 px-3 text-left">Package Details</th>
              <th className="py-2 px-3 text-left">Payment</th>
              <th className="py-2 px-3 text-left">Customer Details</th>
              <th className="py-2 px-3 text-left">Pickup Address</th>
              <th className="py-2 px-3 text-left">Shiping Details</th>
              <th className="py-2 px-3 text-left">Status</th>
              <th className="py-2 px-3 text-left">Actions</th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>
            {loading ? (
              <tr className="text-center">
                <td colSpan="10" className="py-4">
                  <ThreeDotLoader />
                </td>
              </tr>
            ) : orders.length > 0 ? (
              orders.map((order, index) => (
                <tr
                  key={index}
                  className="border-t hover:bg-gray-50 transition-all text-[12px] font-[400] text-gray-500 relative border-gray-300"
                >
                  <td className="py-2 px-3 whitespace-nowrap  text-center">
                    <input
                      type="checkbox"
                      checked={selectedOrders.includes(order._id)}
                      onChange={() => handleCheckboxChange(order._id)}
                      className="cursor-pointer accent-[#0CBB7D] w-4"
                    />
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap">
                    <Link
                      to={`/dashboard/order/neworder/updateOrder/${order._id}`}
                      className="text-[#0CBB7D] font-medium block"
                    >
                      {order.orderId}
                    </Link>
                    <p className="text-gray-500 text-[10px]">
                      {new Date(order.createdAt).toLocaleDateString()}
                      <br />
                      {new Date(order.createdAt).toLocaleTimeString()}
                    </p>
                    <p className="inline-block text-white text-[8px] font-[600] bg-[#0CBB7D] py-1 px-2 rounded-lg">
                      Custom
                    </p>
                  </td>
                  <td
                    className="py-2 px-3 whitespace-normal"
                    style={{ maxWidth: "300px", width: "200px" }}
                  >
                    <p>
                      Name :{" "}
                      {order.productDetails?.map((p) => p.name).join(", ") ||
                        "-"}
                    </p>
                    <p>
                      SKU :{" "}
                      {order.productDetails?.map((p) => p.sku).join(", ") ||
                        "-"}
                    </p>
                    
                    <p>
                      Price :{" "}
                      {order.productDetails
                        ?.map((p) => p.unitPrice)
                        .join(", ") || "-"}
                    </p>
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap">
                    <p>Weight: {order.applicableWeight}</p>
                    <p>
                      L*W*H: {order.packageDetails[0]?.volumetricWeight?.length}*
                      {order.packageDetails[0]?.volumetricWeight?.width}*
                      {order.packageDetails[0]?.volumetricWeight?.height}
                    </p>
                    <p>
                      Vol. Weight:{" "}
                      {(
                        (order.packageDetails[0]?.volumetricWeight?.length *
                          order.packageDetails[0]?.volumetricWeight?.width *
                          order.packageDetails[0]?.volumetricWeight?.height) /
                        5000
                      ).toFixed(2)}
                    </p>
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap">
                    <p className="font-[600]">{order.paymentDetails.amount}</p>
                    <p className="inline-block text-white text-[8px] font-[600] bg-[#0CBB7D] py-1 px-2 rounded-lg">
                      {order.paymentDetails.method}
                    </p>
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap">
                    <p>{order.receiverAddress.contactName}</p>
                    <p className="text-gray-500">
                      {order.receiverAddress.email}
                    </p>
                    <div className="flex gap-2">
                      <p className="text-gray-500">
                        {order.receiverAddress.phoneNumber}
                      </p>
                      <p className="cursor-pointer text-[#0CBB7D] relative group">
                        <i className="fas fa-info-circle"></i>

                        {/* Tooltip (Address Popup) */}
                        <div
                          className="absolute z-50 invisible opacity-0 group-hover:visible group-hover:opacity-100 
             transition-opacity duration-200 bg-white border border-gray-200 text-[11px] 
             text-gray-700 p-3 rounded-md shadow-xl max-w-xs w-auto max-h-56 overflow-y-auto top-1/2 left-[20px] ml-2 transform -translate-y-1/2"
                          style={{
                            pointerEvents: "none", // prevent stealing focus
                          }}
                        >
                          {/* Arrow */}
                          <div
                            className="absolute -left-2 top-3 w-3 h-3 rotate-45 bg-white border-t border-l border-gray-200 shadow-sm"
                            style={{ pointerEvents: "none" }}
                          ></div>

                          {/* Address Information */}
                          <p className="font-semibold">Address:</p>
                          <p className="break-words text-[10px]">
                            {order.receiverAddress.address}
                          </p>
                          <p className="text-[10px]">
                            {order.receiverAddress.state},{" "}
                            {order.receiverAddress.city} ,
                            {order.receiverAddress.pinCode}
                          </p>
                        </div>
                      </p>
                    </div>
                  </td>

                  <td className="py-2 px-3 whitespace-nowrap">
                    <div className="flex gap-2">
                      <p className="text-gray-500">
                        {order.pickupAddress.contactName}
                      </p>
                      <p className="cursor-pointer text-[#0CBB7D] relative group">
                        <i className="fas fa-info-circle"></i>

                        {/* Tooltip (Address Popup) */}
                        <div
                          className="absolute z-50 invisible opacity-0 group-hover:visible group-hover:opacity-100 
          transition-opacity duration-200 bg-white border border-gray-200 text-[11px] 
          text-gray-700 p-3 rounded-md shadow-xl max-h-56 w-[300px] overflow-y-auto top-1/2 left-[20px] ml-2 transform -translate-y-1/2"
                          style={{
                            pointerEvents: "none", // prevent stealing focus
                          }}
                        >
                          {/* Arrow */}
                          <div
                            className="absolute -left-2 top-3 w-3 h-3 rotate-45 bg-white border-t border-l border-gray-200 shadow-sm"
                            style={{ pointerEvents: "none" }}
                          ></div>

                          {/* Address Information */}
                          <p className="font-semibold text-[10px]">Address:</p>
                          <p className="break-words text-[10px]">
                            {order.pickupAddress.address}
                          </p>
                          <p className="text-[10px]">
                            {order.pickupAddress.state},{" "}
                            {order.pickupAddress.city},{" "}
                            {order.pickupAddress.pinCode}
                          </p>
                        </div>
                      </p>
                    </div>
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap">
                    <p>{order.courierServiceName}</p>
                    <p className="text-[10px]">
                      Booked on:{" "}
                      {new Date(order.shipmentCreatedAt).toLocaleDateString()}
                    </p>

                    <p>
                      Waybill No.:{" "}
                      <span
                        className="text-[#0CBB7D] cursor-pointer"
                        onClick={() => handleTrackingByAwb(order.awb_number)}
                      >
                        {order.awb_number}
                      </span>
                    </p>
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap">
                    <span
                      className={`px-2 py-1 rounded text-[10px] md:text-[10px] ${
                        order.status === "new" ||
                        order.status === "Ready To Ship"
                          ? "bg-green-100 text-[#0CBB7D]"
                          : order.status === "Delivered"
                          ? "bg-green-100 text-[#0CBB7D]"
                          : order.status === "Cancelled"
                          ? "bg-red-100 text-red-700"
                          : "bg-green-100 text-[#0CBB7D]" // Default case
                      }`}
                    >
                      {order.status}
                    </span>
                  </td>
                  <td className="py-2 px-3 whitespace-nowrap">
                    <div className="flex items-center">
                      {/* {(order.status === "Ready To Ship" ||
                        order.status === "In-transit") && (
                        <button
                          className="px-3 py-2 me-3 bg-[#0CBB7D] text-white rounded-lg text-[10px]"
                          onClick={() => handleManifest(order._id)}
                        >
                          Download Manifest
                        </button>
                      )}

                      {order.status === "Cancelled" && (
                        <button
                          className="px-3 py-2 me-3 bg-[#0CBB7D] text-white rounded-lg text-[10px]"
                          onClick={() => handleClone(order._id)}
                        >
                          Clone Order
                        </button>
                      )}

                      {order.status === "new" && (
                        <button
                          className="px-3 py-2 me-3 bg-[#0CBB7D] text-white rounded-lg text-[10px]"
                          onClick={() =>
                            navigate(
                              `/dashboard/order/courierSelection/${order._id}`
                            )
                          }
                        >
                          Ship Now
                        </button>
                      )} */}

                      <div
                        className="relative"
                        ref={(el) => {
                          if (el) dropdownRefs.current[index] = el;
                        }}
                      >
                        <button
                          ref={(el) => {
                            if (el) toggleButtonRefs.current[index] = el;
                          }}
                          // ✅ Imp
                          className="px-2 py-2 flex items-center justify-center bg-[#0CBB7D] text-white rounded-full"
                          onClick={() => toggleDropdown(index)}
                        >
                          <FiMoreHorizontal className="text-[12px]" />
                        </button>
                        {dropdownOpen === index && (
                          <div className="absolute right-0 mt-2 w-36 bg-white border border-gray-200 rounded-md shadow-lg z-50">
                            <ul className="py-2">
                              <li className="px-3 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer">
                                <button
                                  onClick={(e) => {
                                    handleInvoice(order._id);
                                    e.stopPropagation();
                                    setDropdownOpen(null);
                                  }}
                                >
                                  Download Invoice
                                </button>
                              </li>
                              <li className="px-3 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer">
                                <button
                                  onClick={(e) => {
                                    handleLabel(order._id);
                                    e.stopPropagation(); // Prevent dropdown from closing
                                    setDropdownOpen(null); // Close dropdown after action
                                  }}
                                >
                                  Download Label
                                </button>
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr className="text-center">
                <td colSpan="10" className="py-4">
                  <p className="text-gray-500">No orders found.</p>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Mobile View: Display Orders as Cards */}
      <div className="md:hidden w-full space-y-4 text-[10px] font-[600]">
        <div className="p-1 bg-slate-200 rounded-md flex gap-3 items-center">
          <input
            type="checkbox"
            checked={
              selectedOrders.length === orders.length && orders.length > 0
            }
            onChange={handleSelectAll}
            className="cursor-pointer accent-[#0CBB7D] w-3 h-3"
          />
          <span>Select All</span>
        </div>
        <div>
          {loading ? (
            <ThreeDotLoader />
          ) : orders.length > 0 ? (
            orders.map((order, index) => (
              <div
                key={index}
                className="bg-green-50 border mt-3 border-gray-300 rounded-lg shadow-md p-4"
              >
                {order.status === "new" && (
                  <>
                    <div className="flex justify-between items-center">
                      {/* Left Section: Checkbox & Order ID */}
                      <div className="flex items-center gap-3">
                        <input
                          type="checkbox"
                          checked={selectedOrders.includes(order._id)}
                          onChange={() => handleCheckboxChange(order._id)}
                          className="cursor-pointer accent-[#0CBB7D] w-3 h-3"
                        />
                        <span className="flex">
                          <p className="mt-1">Order ID: </p>

                          <Link
                            to={`/dashboard/order/neworder/updateOrder/${order._id}`}
                            className="text-[#0CBB7D] mt-1"
                          >
                            {order.orderId}
                          </Link>
                          <p className="ml-3 px-2 py-1 rounded bg-blue-100 text-[#0CBB7D]">
                            {order.status}
                          </p>
                        </span>
                      </div>
                      <div>
                        <button
                          className="px-3 py-2 text-gray-700 rounded-lg"
                          onClick={() => toggleDropdown(index)}
                        >
                          <FiMoreHorizontal size={20} className="text-black" />
                        </button>
                        {dropdownOpen === index && (
                          <>
                            <div
                              className="fixed inset-0 z-40 md:hidden"
                              onClick={() => setDropdownOpen(null)}
                            >
                              {" "}
                            </div>
                            <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-md shadow-lg z-50">
                              <ul className="py-2">
                                <li
                                  onClick={() => {
                                    handleInvoice(order._id);
                                  }}
                                  className="px-3 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer"
                                >
                                  Download Invoice
                                </li>
                                <li className="px-3 py-2 text-red-500 hover:bg-gray-100 cursor-pointer">
                                  <button
                                    onClick={() => handleCancelOrder(order._id)}
                                  >
                                    {" "}
                                    Cancel Order
                                  </button>
                                </li>
                                <li className="px-3 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer">
                                  Archive Order
                                </li>
                              </ul>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    <p className="text-[10px] mb-1 text-gray-500">
                      <span>Order Created On: </span>
                      <span>
                        {new Date(order.createdAt).toLocaleString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                          hour12: true,
                        })}
                      </span>
                    </p>
                    <div className="flex">
                      <span className="text-[10px] font-[600] text-[#2d054b] bg-green-200 px-2 py-1 rounded">
                        {order.category || "CUSTOM"}
                      </span>
                    </div>
                    <div>
                      <p className="text-gray-600 text-[10px] mt-1">
                        Applicable Weight:{" "}
                        <strong>
                          {order.applicableWeight || 0} KG
                        </strong>
                      </p>
                    </div>

                    <div className="flex justify-between items-center mt-1 text-[10px]">
                      <div>
                        <p className="text-gray-700 text-[10px]">
                          {order?.pickupAddress?.pinCode || "N/N"}
                        </p>
                        <p className="text-gray-600 text-[10px]">
                          {order?.pickupAddress?.city || "N/N"},
                          {order?.pickupAddress?.state || "N/N"}
                        </p>
                      </div>
                      <span className="text-gray-500 text-[12px] mb-2">→</span>
                      <div className="text-right">
                        <p className="text-gray-700 text-[10px]">
                          {order?.receiverAddress?.pinCode || "N/N"}
                        </p>
                        <p className="text-gray-600 text-[10px]">
                          {order?.receiverAddress?.city || "N/N"},
                          {order?.receiverAddress?.state || "N/N"}
                        </p>
                      </div>
                    </div>
                    <div className="flex flex-nowrap justify-between items-center mt-3 p-3 bg-green-200 rounded-lg gap-x-1">
                      <p className="text-gray-700 font-[600] text-[10px] text-center truncate max-w-[100px]">
                        {order?.receiverAddress?.contactName || "N/N"}
                      </p>
                      <span className="text-gray-500 text-[10px]">|</span>
                      <p className="text-[#2d054b] text-[10px] text-center truncate max-w-[80px]">
                        {order?.paymentDetails?.method || "N/N"}
                      </p>
                      <span className="text-gray-500 text-[10px]">|</span>
                      <p className="font-[600] text-[10px] text-center truncate max-w-[80px]">
                        ₹{order?.paymentDetails?.amount || "N/N"}
                      </p>
                      <button
                        className="px-3 py-2 bg-[#0CBB7D] text-white rounded-lg text-[10px] flex-shrink-0 min-w-[70px] min-h-[33px]"
                        onClick={() =>
                          navigate(
                            `/dashboard/order/courierSelection/${order._id}`
                          )
                        }
                      >
                        Ship Now
                      </button>
                    </div>
                  </>
                )}
                {(order.status === "Delivered" ||
                  order.status === "Out for Delivery" ||
                  order.status === "RTO" ||
                  order.status === "RTO In-transit" ||
                  order.status === "RTO Delivered") && (
                  <>
                    <div className="flex justify-between items-center">
                      {/* Left Section: Checkbox & Order ID */}
                      <div className="flex items-center gap-3">
                        <input
                          type="checkbox"
                          checked={selectedOrders.includes(order._id)}
                          onChange={() => handleCheckboxChange(order._id)}
                          className="cursor-pointer accent-[#0CBB7D] w-3 h-3"
                        />
                        <span className="flex">
                          <p className="font-[600] mt-1 text-[10px]">
                            Order ID:{" "}
                          </p>

                          <Link
                            to={`/dashboard/order/neworder/updateOrder/${order._id}`}
                            className="text-[#0CBB7D] font-[600] mt-1 text-[10px]"
                          >
                            {order.orderId}
                          </Link>
                          <p className="ml-2 font-[600] px-2 py-1 rounded text-[10px] bg-green-100 text-green-700">
                            {order.status}
                          </p>
                        </span>
                      </div>
                      <div>
                        <button
                          className="px-3 py-2 text-gray-700 rounded-lg text-[10px]"
                          onClick={() => toggleDropdown(index)}
                        >
                          <FiMoreHorizontal size={20} className="text-black" />
                        </button>
                        {dropdownOpen === index && (
                          <>
                            <div
                              className="fixed inset-0 z-40 md:hidden"
                              onClick={() => setDropdownOpen(null)}
                            >
                              {" "}
                            </div>
                            <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-md shadow-lg z-50">
                              <ul className="py-2">
                                <li
                                  onClick={() => {
                                    handleInvoice(order._id);
                                  }}
                                  className="px-4 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer"
                                >
                                  Download Invoice
                                </li>
                              </ul>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="flex items-center justify-between bg-green-200 p-3 rounded-lg shadow-md gap-3">
                      {/* Courier Logo & Details */}
                      <div className="flex items-center gap-3">
                        <img
                          src={carrierLogos[order.provider] || Shadowfax}
                          alt={order.courierServiceName}
                          className="w-8 h-8 rounded-full border-2 border-gray-400"
                        />
                        <div>
                          <p className="text-[10px] font-[600] text-gray-800">
                            {order.courierServiceName}
                          </p>
                          <p className="text-[10px] text-gray-600">
                            Waybill No.:{" "}
                            <span
                              onClick={() =>
                                handleTrackingByAwb(order.awb_number)
                              }
                              className="text-[#0CBB7D] text-[10px] cursor-pointer font-[600]"
                            >
                              {order.awb_number}
                            </span>
                          </p>
                        </div>
                      </div>

                      {/* Payment Details */}
                      <div className="text-right">
                        <p className="text-[10px] text-[#2d054b] truncate max-w-[100px]">
                          {order?.paymentDetails?.method || "N/N"}
                        </p>
                        <p className="font-[600] text-[10px] truncate max-w-[100px]">
                          ₹{order?.paymentDetails?.amount || "N/N"}
                        </p>
                      </div>
                    </div>
                    <p className="text-[10px] mt-2 mb-1 text-gray-500">
                      <span>Delivered on: </span>
                      <span>
                        {order.tracking?.length > 0
                          ? new Date(
                              order.tracking[order.tracking.length - 1]
                                ?.StatusDateTime || ""
                            ).toLocaleString("en-US", {
                              year: "numeric",
                              month: "long",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                              second: "2-digit",
                              hour12: true,
                            })
                          : "No tracking available"}
                      </span>
                    </p>
                    <div className="flex">
                      <span className="text-[10px] font-[600] text-[#2d054b] bg-green-200 px-2 py-1 rounded">
                        {order.category || "CUSTOM"}
                      </span>
                    </div>
                    <div>
                      <p className="text-gray-600 text-[10px] mt-1">
                        Applicable Weight:{" "}
                        <strong>
                          {order.applicableWeight || 0} KG
                        </strong>
                      </p>
                    </div>
                    <div className="flex justify-between items-center mt-1 text-[10px]">
                      <div>
                        <p className="text-gray-700 text-[10px]">
                          {order?.pickupAddress?.pinCode || "N/N"}
                        </p>
                        <p className="text-gray-600 text-[10px]">
                          {order?.pickupAddress?.city || "N/N"},
                          {order?.pickupAddress?.state || "N/N"}
                        </p>
                        {/* <p className="text-gray-700 font-medium text-[10px] text-center truncate max-w-[100px]">
                              {order?.pickupAddress?.contactName || "N/N"}
                            </p> */}
                      </div>
                      <span className="text-gray-500 text-[12px] mb-2">→</span>
                      <div className="text-right">
                        <p className="text-gray-700 text-[10px]">
                          {order?.receiverAddress?.pinCode || "N/N"}
                        </p>
                        <p className="text-gray-600 text-[10px]">
                          {order?.receiverAddress?.city || "N/N"},
                          {order?.receiverAddress?.state || "N/N"}
                        </p>
                        {/* <p className="text-gray-700 font-medium text-[10px] text-center truncate max-w-[100px]">
                              {order?.receiverAddress?.contactName || "N/N"}
                            </p> */}
                      </div>
                    </div>
                  </>
                )}

                {order.status === "Ready To Ship" && (
                  <>
                    <div className="flex justify-between items-center">
                      {/* Left Section: Checkbox & Order ID */}
                      <div className="flex items-center gap-3">
                        <input
                          type="checkbox"
                          checked={selectedOrders.includes(order._id)}
                          onChange={() => handleCheckboxChange(order._id)}
                          className="cursor-pointer accent-[#0CBB7D] w-3 h-3"
                        />
                        <span className="flex">
                          <p className="font-medium mt-1 text-[10px]">
                            Order ID:{" "}
                          </p>

                          <Link
                            to={`/dashboard/order/neworder/updateOrder/${order._id}`}
                            className="text-[#0CBB7D] font-[600] mt-1 text-[10px]"
                          >
                            {order.orderId}
                          </Link>
                          <p className="ml-2 font-[600] px-2 py-1 text-[10px] bg-green-100 text-green-700 rounded">
                            {order.status}
                          </p>
                        </span>
                      </div>
                      <div>
                        <button
                          className="px-3 py-2 text-gray-700 rounded-lg text-[10px]"
                          onClick={() => toggleDropdown(index)}
                        >
                          <FiMoreHorizontal size={20} className="text-black" />
                        </button>
                        {dropdownOpen === index && (
                          <>
                            <div
                              className="fixed inset-0 z-40 md:hidden"
                              onClick={() => setDropdownOpen(null)}
                            >
                              {" "}
                            </div>
                            <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-md shadow-lg z-50">
                              <ul className="text-[10px] font-[600]">
                                <li className="px-3 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer">
                                  <button
                                    onClick={() => handleManifest(order._id)}
                                  >
                                    Download Manifest
                                  </button>
                                </li>
                                <li className="px-3 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer">
                                  <button
                                    onClick={() => handleInvoice(order._id)}
                                  >
                                    Download Invoice
                                  </button>
                                </li>
                                <li className="px-3 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer">
                                  <button
                                    onClick={() => handleLabel(order._id)}
                                  >
                                    Download Label
                                  </button>
                                </li>

                                <li className="px-3 py-2 text-red-500 hover:bg-gray-100 cursor-pointer">
                                  <button
                                    className={` text-red-500 hover:bg-gray-100 cursor-pointer ${
                                      loadingOrderId === order._id
                                        ? "opacity-50 cursor-not-allowed"
                                        : ""
                                    }`}
                                    onClick={() => handleCancelOrder(order)}
                                    disabled={loadingOrderId === order._id}
                                  >
                                    {loadingOrderId === order._id
                                      ? "Cancelling..."
                                      : "Cancel Shipment"}
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="flex items-center justify-between bg-green-200 p-3 rounded-lg shadow-md gap-3">
                      {/* Courier Logo & Details */}
                      <div className="flex items-center gap-3">
                        <img
                          src={carrierLogos[order.provider] || Shadowfax}
                          alt={order.courierServiceName}
                          className="w-8 h-8 rounded-full border-2 border-gray-400"
                        />
                        <div>
                          <p className="text-[10px] font-[600] text-gray-800">
                            {order.courierServiceName}
                          </p>
                          <p className="text-[10px] text-gray-600">
                            Waybill No.:{" "}
                            <span
                              onClick={() =>
                                handleTrackingByAwb(order.awb_number)
                              }
                              className="text-[#0CBB7D] text-[10px] cursor-pointer font-[600]"
                            >
                              {order.awb_number}
                            </span>
                          </p>
                        </div>
                      </div>

                      {/* Payment Details */}
                      <div className="text-right">
                        <p className="text-[10px] text-[#2d054b] truncate max-w-[100px]">
                          {order?.paymentDetails?.method || "N/N"}
                        </p>
                        <p className="font-[10px] text-[10px] truncate max-w-[100px]">
                          ₹{order?.paymentDetails?.amount || "N/N"}
                        </p>
                      </div>
                    </div>
                    <p className="text-[10px] mt-2 mb-1 text-gray-500">
                      <span>Booked on: </span>
                      <span>
                        {new Date(order.shipmentCreatedAt).toLocaleString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true,
                          }
                        )}
                      </span>
                    </p>
                    <div className="flex">
                      <span className="text-[10px] font-[600] text-[#2d054b] bg-green-200 px-2 py-1 rounded">
                        {order.category || "CUSTOM"}
                      </span>
                    </div>
                    <div>
                      <p className="text-gray-600 text-[10px] mt-1">
                        Applicable Weight:{" "}
                        <strong>
                          {order.applicableWeight || 0} KG
                        </strong>
                      </p>
                    </div>
                    <div className="flex justify-between items-center mt-1 text-[10px]">
                      <div>
                        <p className="text-gray-700 text-[10px]">
                          {order?.pickupAddress?.pinCode || "N/N"}
                        </p>
                        <p className="text-gray-600 text-[10px]">
                          {order?.pickupAddress?.city || "N/N"},
                          {order?.pickupAddress?.state || "N/N"}
                        </p>
                        {/* <p className="text-gray-700 font-medium text-[10px] text-center truncate max-w-[100px]">
                              {order?.pickupAddress?.contactName || "N/N"}
                            </p> */}
                      </div>
                      <span className="text-gray-500 text-[12px] mb-2 ">→</span>
                      <div className="text-right">
                        <p className="text-gray-700 text-[10px]">
                          {order?.receiverAddress?.pinCode || "N/N"}
                        </p>
                        <p className="text-gray-600 text-[10px]">
                          {order?.receiverAddress?.city || "N/N"},
                          {order?.receiverAddress?.state || "N/N"}
                        </p>
                      </div>
                    </div>
                  </>
                )}
                {order.status === "In-transit" && (
                  <>
                    <div className="flex justify-between items-center text-[10px] font-[600]">
                      {/* Left Section: Checkbox & Order ID */}
                      <div className="flex items-center gap-3">
                        <input
                          type="checkbox"
                          checked={selectedOrders.includes(order._id)}
                          onChange={() => handleCheckboxChange(order._id)}
                          className="cursor-pointer accent-[#0CBB7D] w-3 h-3"
                        />
                        <span className="flex">
                          <p className="font-[600] mt-1 text-[10px]">
                            Order ID:{" "}
                          </p>

                          <Link
                            to={`/dashboard/order/neworder/updateOrder/${order._id}`}
                            className="text-[#0CBB7D] font-[600] mt-1 text-[10px]"
                          >
                            {order.orderId}
                          </Link>
                          <p className="ml-2 font-[600] px-2 py-1 rounded text-[10px] bg-green-100 text-green-700">
                            {order.status}
                          </p>
                        </span>
                      </div>
                      <div>
                        <button
                          className="px-3 py-2 text-gray-700 rounded-lg text-[10px] font-[600]"
                          onClick={() => toggleDropdown(index)}
                        >
                          <FiMoreHorizontal size={20} className="text-black" />
                        </button>
                        {dropdownOpen === index && (
                          <>
                            <div
                              className="fixed inset-0 z-40 md:hidden"
                              onClick={() => setDropdownOpen(null)}
                            >
                              {" "}
                            </div>
                            <div className="absolute right-0 mt-2 w-40 bg-white border border-gray-200 rounded-md shadow-lg z-50">
                              <ul className="text-[10px] font-[600]">
                                <li className="px-3 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer">
                                  <button
                                    onClick={() => handleManifest(order._id)}
                                  >
                                    Download Manifest
                                  </button>
                                </li>
                                <li className="px-3 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer">
                                  <button
                                    onClick={() => handleInvoice(order._id)}
                                  >
                                    Download Invoice
                                  </button>
                                </li>
                                <li className="px-3 py-2 text-gray-700 hover:bg-gray-100 cursor-pointer">
                                  <button
                                    onClick={() => handleLabel(order._id)}
                                  >
                                    Download Label
                                  </button>
                                </li>
                              </ul>
                            </div>
                          </>
                        )}
                      </div>
                    </div>
                    <div className="flex items-center justify-between bg-green-200 p-3 rounded-lg shadow-md gap-3">
                      {/* Courier Logo & Details */}
                      <div className="flex items-center gap-3">
                        <img
                          src={carrierLogos[order.provider] || Shadowfax}
                          alt={order.courierServiceName}
                          className="w-8 h-8 rounded-full border-2 border-gray-400"
                        />
                        <div>
                          <p className="text-[10px] font-[600] text-gray-800">
                            {order.courierServiceName}
                          </p>
                          <p className="text-[10px] text-gray-600">
                            Waybill No.:{" "}
                            <span
                              onClick={() =>
                                handleTrackingByAwb(order.awb_number)
                              }
                              className="text-[#0CBB7D] text-[10px] cursor-pointer font-[600]"
                            >
                              {order.awb_number}
                            </span>
                          </p>
                        </div>
                      </div>

                      {/* Payment Details */}
                      <div className="text-right">
                        <p className="text-[10px] text-[#2d054b] truncate max-w-[100px]">
                          {order?.paymentDetails?.method || "N/N"}
                        </p>
                        <p className="font-[600] text-[10px] truncate max-w-[100px]">
                          ₹{order?.paymentDetails?.amount || "N/N"}
                        </p>
                      </div>
                    </div>
                    <p className="text-[10px] mt-2 mb-1 text-gray-500">
                      <span>Booked on: </span>
                      <span>
                        {new Date(order.shipmentCreatedAt).toLocaleString(
                          "en-US",
                          {
                            year: "numeric",
                            month: "long",
                            day: "numeric",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                            hour12: true,
                          }
                        )}
                      </span>
                    </p>
                    <div className="flex">
                      <span className="text-[10px] font-[600] text-[#2d054b] bg-green-200 px-2 py-1 rounded">
                        {order.category || "CUSTOM"}
                      </span>
                    </div>
                    <div>
                      <p className="text-gray-600 text-[10px] mt-1">
                        Applicable Weight:{" "}
                        <strong>
                          {order.applicableWeight || 0} KG
                        </strong>
                      </p>
                    </div>
                    <div className="flex justify-between items-center mt-1 text-[10px]">
                      <div>
                        <p className="text-gray-700 text-[10px]">
                          {order?.pickupAddress?.pinCode || "N/N"}
                        </p>
                        <p className="text-gray-600 text-[10px]">
                          {order?.pickupAddress?.city || "N/N"},
                          {order?.pickupAddress?.state || "N/N"}
                        </p>
                        {/* <p className="text-gray-700 font-medium text-[10px] text-center truncate max-w-[100px]">
                                      {order?.pickupAddress?.contactName || "N/N"}
                                    </p> */}
                      </div>
                      <span className="text-gray-500 text-[12px] mb-2">→</span>
                      <div className="text-right">
                        <p className="text-gray-700 text-[10px]">
                          {order?.receiverAddress?.pinCode || "N/N"}
                        </p>
                        <p className="text-gray-600 text-[10px]">
                          {order?.receiverAddress?.city || "N/N"},
                          {order?.receiverAddress?.state || "N/N"}
                        </p>
                      </div>
                    </div>
                  </>
                )}

                {order.status === "Cancelled" && (
                  <>
                    <div className="flex justify-between items-center text-[10px] font-[600]">
                      {/* Left Section: Checkbox & Order ID */}
                      <div className="flex items-center gap-3">
                        <input
                          type="checkbox"
                          checked={selectedOrders.includes(order._id)}
                          onChange={() => handleCheckboxChange(order._id)}
                          className="cursor-pointer accent-[#0CBB7D] w-3 h-3"
                        />
                        <span className="flex">
                          <p className="font-[600] mt-1 text-[10px]">
                            Order ID:{" "}
                          </p>

                          <Link
                            to={`/dashboard/order/neworder/updateOrder/${order._id}`}
                            className="text-[#0CBB7D] font-[600] mt-1 text-[10px]"
                          >
                            {order.orderId}
                          </Link>
                          <p className="ml-3 font-[600] px-2 py-1 rounded text-[10px] bg-red-100 text-red-700">
                            {order.status}
                          </p>
                        </span>
                      </div>
                    </div>
                    <p className="text-[10px] mb-1 text-gray-500">
                      <span>Order Created On: </span>
                      <span>
                        {new Date(order.createdAt).toLocaleString("en-US", {
                          year: "numeric",
                          month: "long",
                          day: "numeric",
                          hour: "2-digit",
                          minute: "2-digit",
                          second: "2-digit",
                          hour12: true,
                        })}
                      </span>
                    </p>
                    <div className="flex">
                      <span className="text-[10px] font-[600] text-[#2d054b] bg-green-200 px-2 py-1 rounded">
                        {order.category || "CUSTOM"}
                      </span>
                    </div>
                    <div>
                      <p className="text-gray-600 text-[10px] mt-1">
                        Applicable Weight:{" "}
                        <strong>
                          {order.applicableWeight || 0} KG
                        </strong>
                      </p>
                    </div>
                    <div className="flex justify-between items-center mt-1 text-[10px]">
                      <div>
                        <p className="text-gray-700 text-[10px]">
                          {order?.pickupAddress?.pinCode || "N/N"}
                        </p>
                        <p className="text-gray-600 text-[10px]">
                          {order?.pickupAddress?.city || "N/N"},
                          {order?.pickupAddress?.state || "N/N"}
                        </p>
                      </div>
                      <span className="text-gray-500 text-[12px] mb-2">→</span>
                      <div className="text-right">
                        <p className="text-gray-700 text-[10px]">
                          {order?.receiverAddress?.pinCode || "N/N"}
                        </p>
                        <p className="text-gray-600 text-[10px]">
                          {order?.receiverAddress?.city || "N/N"},
                          {order?.receiverAddress?.state || "N/N"}
                        </p>
                      </div>
                    </div>
                    <div className="flex flex-nowrap justify-between items-center mt-3 p-3 bg-green-200 rounded-lg gap-x-1">
                      <p className="text-gray-700 font-medium text-[10px] text-center truncate max-w-[100px]">
                        {order?.receiverAddress?.contactName || "N/N"}
                      </p>
                      <span className="text-gray-500 text-[10px]">|</span>
                      <p className="text-[#2d054b] text-[10px] text-center flex-shrink-0 max-w-[80px]">
                        {order?.paymentDetails?.method || "N/N"}
                      </p>
                      <span className="text-gray-500 text-[10px]">|</span>
                      <p className="font-[600] text-[10px] text-center flex-shrink-0  max-w-[80px]">
                        ₹{order?.paymentDetails?.amount || "N/N"}
                      </p>
                      <button
                        className="px-3 py-2 bg-[#0CBB7D] text-white rounded-lg text-[10px] flex-shrink-0 min-w-[70px] min-h-[33px]"
                        onClick={() => {
                          handleClone(order._id);
                        }}
                      >
                        Clone Order
                      </button>
                    </div>
                  </>
                )}
              </div>
            ))
          ) : (
            <div className="flex justify-center items-center h-full w-full">
              <p className="text-gray-500 text-[12px]">No orders found</p>
            </div>
          )}
        </div>
      </div>
      <div className="flex justify-between items-center mt-6 gap-4 flex-wrap text-[10px] font-[600]">
        <div className="flex items-center gap-2">
          <label
            htmlFor="limit"
            className="text-gray-700 text-[10px] font-[600]"
          >
            Show:
          </label>
          <select
            id="limit"
            value={limit}
            onChange={(e) => {
              const selected = e.target.value;
              if (selected === "All") {
                setLimit(null); // null means no limit
                setPage(1);
              } else {
                setLimit(parseInt(selected));
                setPage(1); // reset to first page when changing limit
              }
            }}
            className="px-3 py-2 border rounded-md text-[10px]"
          >
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={75}>75</option>
            <option value={100}>100</option>
            <option value="All">All</option>
          </select>
        </div>

        <div className="flex items-center gap-4">
          <button
            onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
            disabled={page === 1}
            className="py-2 px-3 bg-gray-300 rounded disabled:opacity-50"
          >
            <FiArrowLeft />
          </button>
          <span className="text-gray-700 text-[10px]">
            Page {page} of {totalPages}
          </span>
          <button
            onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
            disabled={page === totalPages}
            className="py-2 px-3 bg-gray-300 rounded disabled:opacity-50"
          >
            <FiArrowRight />
          </button>
        </div>
      </div>
    </div>
  );
};

export default AllOrder;
